<template>
    <el-form size="mini" :model="form" :inline=true>
        <el-form-item label="申请时间">
            <el-date-picker
                    v-model="form.startTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="开始日期" style="width: 180px">
            </el-date-picker>
            <span class="split">-</span>
            <el-date-picker
                    v-model="form.endTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="结束日期" style="width: 180px">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="患者姓名">
            <el-input v-model="form.patName" placeholder="患者姓名"></el-input>
        </el-form-item>
        <el-form-item label="预约医院">
            <el-select v-model="form.hopeHosId">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(data,index) in hopeHosIds" :key="index" :label="data.hosName"
                           :value="data.consultGroupHosId"></el-option>
            </el-select>
        </el-form-item>
        <!-- 页面判断显示 -->
        <el-form-item label="预约项目" v-if="$route.params.type == 'check'">
            <el-input v-model="form.itemId" placeholder="请输入预约项目"></el-input>
        </el-form-item>
        <el-form-item label="预约手术" v-else>
            <el-input v-model="form.itemId" placeholder="请输入预约手术"></el-input>
        </el-form-item>

        <el-form-item>
            <el-button type="success" @click="query">查询</el-button>
            <el-button type="primary" @click="apply">发起转诊</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import {getOneYearTime} from '../../lib/hos/until';
    import {consultationService} from "../../lib/service/consultation";
    import {hosService} from "../../lib/service/hos"
    export default {
        name: "hos-search-from",
        data(){
            return {
                form:{
                    startTime:'',
                    endTime:'',
                    patName:'',
                    hopeHosId:'',
                    itemId:''
                },
                hopeHosIds:[],//医院
                hopeSurgerys:[],//手术
                hopeItems:[]//检查
            }
        },
        methods:{
            getForm(){
                let form = {
                    startTime:this.form.startTime,
                    endTime:this.form.endTime,
                    patName:this.form.patName,
                    hopeHosId:this.form.hopeHosId
                }
                if(this.$route.params.type == 'check'){
                    form.inspectName = this.form.itemId
                }else{
                    form.operationName = this.form.itemId
                }
                return form;
            },
            //设置默认时间
            setDefalutTime(){
                const timeObj = getOneYearTime();
                this.form.endTime = timeObj.end;
                this.form.startTime = timeObj.start;
            },
            apply(){
                let type = this.$route.params.type;
                this.$router.push(`/main/referral/hos/${type}/apply`);//转诊申请页面
            },
            //预约医院
            async hopeHosList(){
                this.hopeHosIds = await consultationService.groupHosList(this.docInfo.hosId);
            },
            query(){
                this.$emit('queryData');
            },
            async getList(){
                this.form.itemId = '';
                if(this.form.hopeHosId == '')return
                //获取检查项目
                if(this.$route.params.type == 'check'){
                    this.hopeItems = await hosService.getInspectList({
                        hosId:this.form.hopeHosId
                    })
                }else{
                    //获取手术项目
                    this.hopeSurgerys = await hosService.getSurgeryList({
                        hosId:this.form.hopeHosId
                    })
                }
            },
        },
        created(){
            this.setDefalutTime();
            this.hopeHosList();
        },
        mounted() {
            this.$emit('queryData');
        }
    }
</script>

<style lang="scss" scoped>
.split{
    margin: 0 10px;
    color:#999999
}
</style>